<script setup lang="ts">
import { computed } from 'vue'

import cn from 'internal/tailwind-classmerge'

import { PopoverContent, type PopoverContentProps } from '@fond-of/fondof-ui'

const props = withDefaults(defineProps<PopoverContentProps>(), {
  alignOffset: 0,
  sideOffset: 0,
})

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>
<template>
  <PopoverContent
    v-bind="delegatedProps"
    :class="
      cn(
        'shadow-3xl z-popover bg-white p-4 text-black outline-none',
        'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
        'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
        'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        props.class
      )
    "
  >
    <slot />
  </PopoverContent>
</template>
